import React, { useEffect, useState } from "react";
import styled from "styled-components";
import MayoLogo from "../../tenants/mayo/patientFacing/common/MayoLogo";
import { useNavigate } from "react-router-dom";

import bgImg from "../../assets/Mayo/Avatar_page_bg.png"
import { AGE_OPTIONS, AVATAR_OPTIONS, SEX_OPTIONS } from "../../tenants/mayo/patientFacing/mayo1/MayoChooseAvatar";

function AvatarOptions({text, options, borderBetween=true, OptionComponent, select, selectedValue, gap, errorMsg }) {
  const optionsWrapperStyle = gap ? {gap} : {};

  return (
    <OptionContainer>
      {errorMsg &&
        <OptionText style={{color: "#F02A4C", fontSize: 16}}>
          {errorMsg}
        </OptionText>
      }
      <OptionText>{text}</OptionText>
      <OptionsWrapper
        style={optionsWrapperStyle}
      >
      { options && 
        options.map((option, index) => {
          const isSelected = option.value === selectedValue;
          return <React.Fragment key={index}>
            <OptionComponent 
              onClick={() => !isSelected && select(option)}
              isSelected={isSelected}
              {...option}
              >
            </OptionComponent>
            {borderBetween && index < (options.length - 1) && <OptionGap />}
          </React.Fragment>
        })
      }
      </OptionsWrapper>

    </OptionContainer>
  )
}

function TextOption({text, onClick, isSelected=false}) {
  const style = isSelected ? {opacity: "100%", color: "#82A4FC"} : {};
  return (
    <TextOptionStyled
      onClick={onClick}
      style={style}
    >
      {text}
    </TextOptionStyled>
  );
}

function AvatarOption({image, onClick, isSelected=false}) {
  const borderStyle = isSelected ? {} : {};
  return (
    <Avatar 
      selected={isSelected}
      onClick={onClick}
      src={image}
    />
  );
}

export default function DemoChooseAvatar() {
  const navigate = useNavigate();

  const [selectedSex, setSelectedSex] = useState(null);
  const [selectedAge, setSelectedAge] = useState(null);
  const [selectedAvatar, setSelectedAvatar] = useState(null);

  const [enableChoiceError, setEnableChoiceError] = useState(false);

  const buttonEnabled = selectedSex && selectedAge && selectedAvatar;

  const selectOption = (setOption) => (value) => {
    if(setOption != setSelectedAvatar) {
      setSelectedAvatar(null);
    } else if(selectedAge == null || selectedSex == null) {
      setEnableChoiceError(true);
      return;
    }
    setOption(value);
  }
  
  useEffect(() => {
    if(selectedAge && selectedSex && enableChoiceError) {
      setEnableChoiceError(false);
    }
  }, [selectedAge, selectedSex])

  const filteredAvatarOptions = AVATAR_OPTIONS.filter(avatar => {
    return (
      (selectedSex ? selectedSex === null || avatar.sex === selectedSex.value : true) &&
      (selectedAge ? selectedAge == null || avatar.age === selectedAge.value : true)
    );
  });

  const submitAvatar = async () => {
    if(!selectedAvatar) {
      // Todo - add error message
      return;
    }

    const gender = selectedSex.value.toLowerCase(); 
    const age = selectedAvatar.ageAvatarVal;
    const ethnicity = selectedAvatar.ethnicity;

    const query = new URLSearchParams({
      data: JSON.stringify({gender, age, ethnicity})
    }).toString();
    navigate(`/demo/patient/video?${query}`);
  }
  
  return(
    <Container>
      <MayoLogo/>
      <Title>Choose your avatar</Title>
      <AvatarForm>
        <AvatarOptions 
          text="Choose your sex"
          OptionComponent={TextOption}
          borderBetween={true}
          options={SEX_OPTIONS}
          select={selectOption(setSelectedSex)}
          selectedValue={selectedSex?.value}
        />
        <HL/>
        <AvatarOptions 
          text="Choose your age"
          OptionComponent={TextOption}
          borderBetween={true}
          options={AGE_OPTIONS}
          select={selectOption(setSelectedAge)}
          selectedValue={selectedAge?.value}
        />
        <HL/>
        <AvatarOptions
          errorMsg={enableChoiceError ? "Please fill the previous fields first" : null}
          gap={13}
          borderBetween={false}
          text="Choose your preferred avatar"
          OptionComponent={AvatarOption}
          options={filteredAvatarOptions}
          select={selectOption(setSelectedAvatar)}
          selectedValue={selectedAvatar?.value}
        />
      </AvatarForm>
      <Button onClick={submitAvatar}
        style={buttonEnabled && {opacity: 1}}
      >Next</Button>
    </Container>
  );
}

const Container = styled.div`
  font-family: Abraham;
  min-height: 100vh;
  background-image: url("${bgImg}");
  background-repeat: repeat;
  background-size: cover;
  background-position: center;
`

const Title = styled.p`
  margin: 0;
  margin-bottom: 20px;
  margin-top: 25px;
  margin-left: 29px;

  font-size: 24px;
  font-weight: 600;
  color: #222222;
`

const AvatarForm = styled.div`
  margin-inline: 18px;
  border-radius: 15px;
  background-color: #FFFFFF;
  backdrop-filter: blur(6px);
  box-shadow: 0 3px 6px #0000001A;

  padding: 28px 0 30px 19px;
`

const OptionContainer = styled.div`
`

const OptionsWrapper = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  overflow: hidden;
`

const OptionText = styled.p`
  margin: 0;
  margin-bottom: 14px;
  
  font-size: 19px;
  color: #222222;
`

const OptionGap = styled.div`
  min-width: 1px;
  height: 18px;
  background-color: #EAEAEA;
`

const TextOptionStyled = styled.p`
  margin: 0;
  color: #222222;
  font-size: 19px;
  opacity: 40%;
`

const Avatar = styled.img`
  border-radius: 50%;
  border: 2px solid ${({ selected }) => (selected ? "#84a4fc" : "transparent")};
  margin-top: 10px;
  width: 75px;
  height: 75px;
`;

const Button = styled.button`
  opacity: 50%;
  background-color: #F02A4C;
  color: white;
  font-size: 17px;

  display: block;
  border-radius: 19px;
  border: 0;
  width: 135px;
  height: 37px;
  margin-inline: auto;
  margin-top: 58px;
`

const HL = styled.div`
  height: 1px;
  background-color: #EAEAEA;
  margin-block: 18px;
`